import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Shortcut } from 'types/shortcut';

// Дефолтные горячие клавиши
export const DEFAULT_SHORTCUTS: Shortcut[] = [
  { key: '.', description: 'Выбор компании', command: 'selectCompany', commandType: 'showTool', toolButtonId: 'sellerSelectorButton' },
  { key: '\\', description: 'Обзор', command: 'home', commandType: 'link', link: '/' },
  { key: 'K', description: 'Маркетплейсы Каналы', command: 'markets', commandType: 'link', link: '/marketplaces' },
  { key: 'Z', description: 'Продукты', command: 'products', commandType: 'link', link: '/pim' },
  { key: 'X', description: 'Цены', command: 'prices', commandType: 'link', link: '/offers' },
  { key: 'I', description: 'Остатки', command: 'remains', commandType: 'link', link: '/stocks-fbs' },
  { key: 'O', description: 'Заказы', command: 'Orders', commandType: 'link', link: '/orders' },
  { key: "'", description: 'Склады', command: 'warehouses', commandType: 'link', link: '/warehouses' },
  { key: '[', description: 'Отгрузки', command: 'shipments_sidebar', commandType: 'link', link: '/shipments' },
  { key: ',', description: 'Аналитика', command: 'analytics', commandType: 'link', link: '/analytics' },
  { key: 'Y', description: 'Отзывы', command: 'ai-reviews', commandType: 'link', link: '/ai-reviews' },
  { key: ';', description: 'Инструменты', command: 'Tools', commandType: 'link', link: '/home/tools' },
  { key: ':', description: 'Настройки', command: 'settings', commandType: 'link', link: '/seller/edit/:id' },
  { key: 'H', description: 'Поддержка', command: 'support', commandType: 'showTool', toolButtonId: 'chatMenuButton' },
  { key: '?', description: 'Справка/Документация', command: 'documentation', commandType: 'link', link: '/help' },
  { key: 'B', description: 'Биллинг/Баланс', command: 'billing', commandType: 'link', link: '/billing' },
  { key: 'A', description: 'Аккаунт', command: 'userAccount', commandType: 'showTool', toolButtonId: 'userDropdownButton' },
  { key: 'Q', description: 'Выход', command: 'logout', commandType: 'logout' },
  { key: '`', description: 'Меню', command: 'toggleMenu', commandType: 'showTool', toolButtonId: 'sidebarToggleButton' },
  { key: '/', description: 'Уведомления', command: 'notifications', commandType: 'showTool', toolButtonId: 'hs-pro-dnnd' },
];

// Функции для работы с localStorage
// const loadShortcutsFromStorage = (): Shortcut[] => {
//   try {
//     const savedShortcuts = localStorage.getItem('keyboardShortcuts');
//     if (savedShortcuts) {
//       return JSON.parse(savedShortcuts);
//     }
//   } catch (error) {
//     console.error('Error loading shortcuts from localStorage:', error);
//   }
//   return DEFAULT_SHORTCUTS;
// };

// const saveShortcutsToStorage = (shortcuts: Shortcut[]) => {
//   try {
//     localStorage.setItem('keyboardShortcuts', JSON.stringify(shortcuts));
//   } catch (error) {
//     console.error('Error saving shortcuts to localStorage:', error);
//   }
// };

interface ShortcutsState {
  shortcuts: Shortcut[];
  isModalOpen: boolean;
}

const initialState: ShortcutsState = {
  shortcuts: DEFAULT_SHORTCUTS,
  isModalOpen: false,
};

const shortcutsSlice = createSlice({
  name: 'shortcuts',
  initialState,
  reducers: {
    // Управление модальным окном
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    
    // Управление горячими клавишами
    setShortcuts: (state, action: PayloadAction<Shortcut[]>) => {
      state.shortcuts = action.payload;
      // saveShortcutsToStorage(action.payload);
    },
    
    resetShortcuts: (state) => {
      state.shortcuts = DEFAULT_SHORTCUTS;
      // saveShortcutsToStorage(DEFAULT_SHORTCUTS);
    },
  }
});

export const {
  setModalOpen,
  setShortcuts,
  resetShortcuts,
} = shortcutsSlice.actions;

export default shortcutsSlice.reducer;